var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyntiroLogoNoText(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1153,
    height: 1153,
    viewBox: "30.38 35.70 111.66 111.66",
    role: "img",
    "aria-label": "Syntiro",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #03ac96;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #00ab97;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #006a77;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 85.2,
    y: 40.96,
    width: 2.51,
    height: 100.33
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 106.92,
    y: 53.5,
    width: 2.51,
    height: 75.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 128.65,
    y: 66.04,
    width: 2.51,
    height: 50.17
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 41.76,
    y: 66.04,
    width: 2.51,
    height: 50.17
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 63.48,
    y: 53.5,
    width: 2.51,
    height: 75.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.47,91.13c0,3.87-3.14,7.01-7.01,7.01s-7.01-3.14-7.01-7.01,3.14-7.01,7.01-7.01,7.01,3.14,7.01,7.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.02,91.13c0,3.87-3.14,7.01-7.01,7.01s-7.01-3.14-7.01-7.01,3.14-7.01,7.01-7.01,7.01,3.14,7.01,7.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.18,84.72c-3.39,0-6.14-2.75-6.14-6.14s2.75-6.14,6.14-6.14,6.14,2.75,6.14,6.14-2.75,6.14-6.14,6.14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.18,109.8c-3.39,0-6.14-2.75-6.14-6.14s2.75-6.14,6.14-6.14,6.14,2.75,6.14,6.14-2.75,6.14-6.14,6.14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.46,71.3c-3.39,0-6.14-2.75-6.14-6.14s2.75-6.14,6.14-6.14,6.14,2.75,6.14,6.14-2.75,6.14-6.14,6.14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.46,123.22c-3.39,0-6.14-2.75-6.14-6.13s2.75-6.14,6.14-6.14,6.14,2.75,6.14,6.14-2.75,6.13-6.14,6.13"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.91,91.13c0,3.87-3.14,7.01-7.01,7.01s-7.01-3.14-7.01-7.01,3.14-7.01,7.01-7.01,7.01,3.14,7.01,7.01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,40.96c0-2.9,2.35-5.26,5.26-5.26s5.26,2.35,5.26,5.26-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,141.29c0-2.9,2.35-5.26,5.26-5.26s5.26,2.35,5.26,5.26-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.92,53.5c0-2.9,2.35-5.26,5.26-5.26s5.26,2.35,5.26,5.26-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.92,128.75c0-2.9,2.35-5.26,5.26-5.26s5.26,2.35,5.26,5.26-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.64,66.04c0-2.9,2.35-5.26,5.26-5.26s5.26,2.36,5.26,5.26-2.36,5.26-5.26,5.26-5.26-2.36-5.26-5.26"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.75,66.04c0-2.9,2.35-5.26,5.26-5.26s5.26,2.36,5.26,5.26-2.35,5.26-5.26,5.26-5.26-2.36-5.26-5.26"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.64,116.21c0-2.9,2.35-5.26,5.26-5.26s5.26,2.36,5.26,5.26-2.36,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.75,116.21c0-2.9,2.35-5.26,5.26-5.26s5.26,2.36,5.26,5.26-2.35,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.73,84.72c-3.39,0-6.14-2.75-6.14-6.14s2.75-6.14,6.14-6.14,6.14,2.75,6.14,6.14-2.75,6.14-6.14,6.14"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.73,109.8c-3.39,0-6.14-2.75-6.14-6.14s2.75-6.14,6.14-6.14,6.14,2.75,6.14,6.14-2.75,6.14-6.14,6.14"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.48,53.5c0-2.9,2.35-5.26,5.26-5.26s5.26,2.35,5.26,5.26-2.36,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.48,128.75c0-2.9,2.35-5.26,5.26-5.26s5.26,2.35,5.26,5.26-2.36,5.26-5.26,5.26-5.26-2.35-5.26-5.26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyntiroLogoNoText);
export default __webpack_public_path__ + "static/media/syntiro-logo-no-text.da44a2cb37bca6600e62c2349d257b34.svg";
export { ForwardRef as ReactComponent };